import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setDataLayout } from "../../data/redux/themeSettingSlice";
import { setLanguage } from "../../data/redux/authSlice";

import ImageWithBasePath from "../imageWithBasePath";
import {
  setMobileSidebar,
  toggleMiniSidebar,
} from "../../data/redux/sidebarSlice";
import { all_routes } from "../../../feature-module/router/all_routes";
// import { HorizontalSidebarData } from "../../data/json/horizontalSidebar";
import useAuth from "../../../hooks/useAuth";

import CommonSelect, {
  Option,
} from "../../../feature-module/pages/license-registration-form/CommonSelect";

const Header = () => {
  const routes = all_routes;
  const dispatch = useDispatch();
  const dataLayout = useSelector((state: any) => state.themeSetting.dataLayout);
  const Location = useLocation();
  const userDetails = useSelector((state: any) => state.auth.userDetails);
  const language = useSelector((state:any)=>state.auth.language);
 

const navigate=useNavigate();
 
  const { signOut } = useAuth();
  const [subOpen, setSubopen] = useState<any>("");
  const [subsidebar, setSubsidebar] = useState("");

  const toggleSidebar = (title: any) => {
    localStorage.setItem("menuOpened", title);
    if (title === subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };

  const toggleSubsidebar = (subitem: any) => {
    if (subitem === subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };
  const mobileSidebar = useSelector(
    (state: any) => state.sidebarSlice.mobileSidebar
  );

  const toggleMobileSidebar = () => {
    dispatch(setMobileSidebar(!mobileSidebar));
  };

  

  const handleToggleMiniSidebar = () => {
    if (dataLayout === "mini_layout") {
      //   dispatch(setDataLayout("default_layout"));
      dispatch(toggleMiniSidebar());

      localStorage.setItem("dataLayout", "default_layout");
    } else {
      dispatch(toggleMiniSidebar());
    }
  };

  const handleLogout = async () => {
    dispatch(setDataLayout("default_layout"));

    //.log("logout");
    await signOut();
navigate("/")    ;
  };

  const [isFullscreen, setIsFullscreen] = useState(false);
  const toggleFullscreen = () => {
    if (!isFullscreen) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen().catch((err) => {});
        setIsFullscreen(true);
      }
    } else {
      if (document.exitFullscreen) {
        if (document.fullscreenElement) {
          document.exitFullscreen().catch((err) => {});
        }
        setIsFullscreen(false);
      }
    }
  };

  return (
    <>
      {/* Header */}
      <div className="header">
        <div className="main-header">
          <div className="header-left"></div>

          <Link
            id="mobile_btn"
            onClick={toggleMobileSidebar}
            className="mobile_btn"
            to="#sidebar"
          >
            <span className="bar-icon">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </Link>

          <div className="header-user">
            <div className="nav user-menu nav-list">
              <div
                className="me-auto d-flex align-items-center"
                id="header-search"
              >
                {/* <Link id="toggle_btn" to="#" onClick={handleToggleMiniSidebar} className="btn btn-menubar me-1">
								<i className="ti ti-arrow-bar-to-left"></i>
							</Link> */}
                <div className="d-flex align-items-center text-black fw-bold">
                  {language.g2}
                  {/* <span className="input-icon-addon">
                    <i className="ti ti-search"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                  />
                  <span className="input-group-text">
                    <kbd>CTRL + / </kbd>
                  </span> */}
                </div>

                {/* <Link to={routes.profilesettings} className="btn btn-menubar">
								<i className="ti ti-settings-cog"></i>
							</Link>	 */}
              </div>

              <div
                className="sidebar sidebar-horizontal"
                id="horizontal-single"
              >
                <div className="sidebar-menu">
                  <div className="main-menu">
                    <ul className="nav-menu">
                      <li className="menu-title">
                        <span>{language.main}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-center ">
                

                <div className="d-flex align-items-center">
                  <div className="me-1 text-black ">
                    <span className="sm me-2 text-primary px-2 rounded">{userDetails?.First_Name} {userDetails?.Last_Name}</span>
                    <span className="fw-bold me-2 text-primary px-2 rounded">{userDetails?.Role?.Role_Name}</span>
                    {/* <span className="sm text-primary px-2 rounded">{userDetails?.EMAIL}</span> */}
                  </div>
                  <div className="me-1">
                    <Link
                      to="#"
                      onClick={toggleFullscreen}
                      className="btn btn-menubar btnFullscreen"
                    >
                      <i className="ti ti-maximize"></i>
                    </Link>
                  </div>

              
                {/* <div className="dropdown me-1">
								<Link to="#" className="btn btn-menubar" data-bs-toggle="dropdown">
									<i className="ti ti-layout-grid-remove"></i>
								</Link>
								<div className="dropdown-menu dropdown-menu-end">
									<div className="card mb-0 border-0 shadow-none">
										<div className="card-header">
											<h4>Applications</h4>
										</div>
										<div className="card-body">											
																		
											
										</div>
									</div>
								</div>
							</div>
							<div className="me-1">
								<Link to={routes.chat} className="btn btn-menubar position-relative">
									<i className="ti ti-brand-hipchat"></i>
									<span className="badge bg-info rounded-pill d-flex align-items-center justify-content-center header-badge">5</span>
								</Link>
							</div>
							<div className="me-1">
								<Link to={routes.email} className="btn btn-menubar">
									<i className="ti ti-mail"></i>
								</Link>
							</div> */}

 {/* <div className="me-1 notification_item">
								<Link to="#" className="btn btn-menubar position-relative me-1" id="notification_popup"
									data-bs-toggle="dropdown">
									<i className="ti ti-bell"></i>
									<span className="notification-status-dot"></span>
								</Link>
								<div className="dropdown-menu dropdown-menu-end notification-dropdown p-4">
									<div
										className="d-flex align-items-center justify-content-between border-bottom p-0 pb-3 mb-3">
										<h4 className="notification-title">Notifications (2)</h4>
										<div className="d-flex align-items-center">
											<Link to="#" className="text-primary fs-15 me-3 lh-1">Mark all as read</Link>
											<div className="dropdown">
												<Link to="#" className="bg-white dropdown-toggle"
													data-bs-toggle="dropdown">
													<i className="ti ti-calendar-due me-1"></i>Today
												</Link>
												<ul className="dropdown-menu mt-2 p-3">
													<li>
														<Link to="#" className="dropdown-item rounded-1">
															This Week
														</Link>
													</li>
													<li>
														<Link to="#" className="dropdown-item rounded-1">
															Last Week
														</Link>
													</li>
													<li>
														<Link to="#" className="dropdown-item rounded-1">
															Last Month
														</Link>
													</li>
												</ul>
											</div>
										</div>
									</div>
									<div className="noti-content"> */}
                {/* <div className="d-flex flex-column">
											<div className="border-bottom mb-3 pb-3">
												<Link to={routes.manage_apmc}>
													<div className="d-flex">
														<span className="avatar avatar-lg me-2 flex-shrink-0">
															<ImageWithBasePath src="assets/img/profiles/avatar-27.jpg" alt="Profile"/>
														</span>
														<div className="flex-grow-1">
															<p className="mb-1"><span
																	className="text-dark fw-semibold">Shawn</span>
																performance in Math is below the threshold.</p>
															<span>Just Now</span>
														</div>
													</div>
												</Link>
											</div>
											<div className="border-bottom mb-3 pb-3">
												<Link to={routes.manage_apmc} className="pb-0">
													<div className="d-flex">
														<span className="avatar avatar-lg me-2 flex-shrink-0">
															<ImageWithBasePath src="assets/img/profiles/avatar-23.jpg" alt="Profile"/>
														</span>
														<div className="flex-grow-1">
															<p className="mb-1"><span
																	className="text-dark fw-semibold">Sylvia</span> added
																appointment on 02:00 PM</p>
															<span>10 mins ago</span>
															<div
																className="d-flex justify-content-start align-items-center mt-1">
																<span className="btn btn-light btn-sm me-2">Deny</span>
																<span className="btn btn-primary btn-sm">Approve</span>
															</div>
														</div>
													</div>
												</Link>
											</div>
											<div className="border-bottom mb-3 pb-3">
												<Link to={routes.manage_apmc}>
													<div className="d-flex">
														<span className="avatar avatar-lg me-2 flex-shrink-0">
															<ImageWithBasePath src="assets/img/profiles/avatar-25.jpg" alt="Profile"/>
														</span>
														<div className="flex-grow-1">
															<p className="mb-1">New student record <span className="text-dark fw-semibold"> George</span> 
																is created by <span className="text-dark fw-semibold">Teressa</span>
															</p>
															<span>2 hrs ago</span>
														</div>
													</div>
												</Link>
											</div>
											<div className="border-0 mb-3 pb-0">
												<Link to={routes.manage_apmc}>
													<div className="d-flex">
														<span className="avatar avatar-lg me-2 flex-shrink-0">
															<ImageWithBasePath src="assets/img/profiles/avatar-01.jpg" alt="Profile"/>
														</span>
														<div className="flex-grow-1">
															<p className="mb-1">A new teacher record for <span className="text-dark fw-semibold">Elisa</span> </p>
															<span>09:45 AM</span>
														</div>
													</div>
												</Link>
											</div>
										</div> */}
                {/* </div>
									<div className="d-flex p-0">
										<Link to="#" className="btn btn-light w-100 me-2">Cancel</Link>
										<Link to={routes.manage_apmc} className="btn btn-primary w-100">View All</Link>
									</div>
								</div>
							</div> */}
                <div className=" dropdown profile-dropdown ">
                  <Link
                    to="#"
                    className="dropdown-toggle d-flex  align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <span className="avatar avatar-sm online">
                      <ImageWithBasePath
                        src="assets/img/profiles/avatar-001.png"
                        alt="Img"
                        className="img-fluid rounded-circle"
                      />
                    </span>
                  </Link>
                  <div className="dropdown-menu shadow-none " style={{ width: "300px" }}>
                    <div className="card mb-0">
                      <div className="card-header">
                        <div className="  ">
                          <div className="  w-100">
                            <span className=" avatar avatar-lg me-2 avatar-rounded">
                            <ImageWithBasePath
                              src="assets/img/profiles/avatar-001.png"
                              alt="img"
                            />
                          </span>
                          </div>
                          
                          <div className="">
                            <div className="d-flex align-items-center"><h6 className="mb-1 me-1">Name :</h6>  {userDetails?.First_Name} {userDetails?.Middle_Name?userDetails?.Middle_Name:""} {userDetails?.Last_Name}</div>
                            <div className="d-flex align-items-center">
                              <h6 className="mb-1 me-1">
                              Role :
                            </h6>
                             {userDetails?.Role?.Role_Name}
                            </div>
                            
                            {/* <p className=" mb-1">
                                {userDetails?.Department?.Department_Idetifier}
                            </p> */}
                            <div>
                              <div className=" mb-1 ">
                                {["JC","COM","Dr"].includes(userDetails?.Role?.Role_Identifier) && 
                                <div className="d-flex align-items-center me-1">
                                  <h6 >
                                  District :
                                </h6>
                                <p> {userDetails?.Department?.District}</p>
                                </div>
                                
                                }
                                {["SC","HOS","DY","DT"].includes(userDetails?.Role?.Role_Identifier) && <h6>Head Office</h6>}
                                
                            </div>
                            </div>
                            
                            <div className="d-flex align-items-center">
                              <h6 className=" mb-1 me-1">
                                Email : 
                            </h6>
                            <p>{userDetails?.EMAIL}</p>
                            </div>
                             
                            <div className="d-flex align-items-center">
                              <h6 className=" mb-1 me-1">
                                Mobile No. : 
                            </h6>
                            <p>{userDetails?.MOBILE}</p>
                            </div>
                            
                          </div>
                        </div>
                      </div>
                      {/* <div className="card-body">
                        <Link
                          className="dropdown-item d-inline-flex align-items-center p-0 py-2"
                          to={routes.profile}
                        >
                          <i className="ti ti-user-circle me-1"></i>My Profile
                        </Link>

                        <Link
                          className="dropdown-item d-inline-flex align-items-center p-0 py-2"
                          to={routes.profilesettings}
                        >
                          <i className="ti ti-circle-arrow-up me-1"></i>My
                          Account
                        </Link>
                      </div> */}
                      <div className="card-footer">
                        <button
                          className="dropdown-item d-inline-flex align-items-center p-0 py-2"
                          onClick={handleLogout}
                        >
                          <i className="ti ti-login me-2"></i>{language.logout}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="dropdown mobile-user-menu">
              <Link
                to="#"
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fa fa-ellipsis-v"></i>
              </Link>
              <div className="dropdown-menu dropdown-menu-end">
              

                <button className="dropdown-item" onClick={handleLogout}>
                  {language.logout}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      {/* /Header */}
    </>
  );
};

export default Header;
